import React from 'react'
import {
  Themis,
  Cppro,
  SpreadsheetMigration
} from './views';
import Full from './containers/Full';
import AuthenticatedRoute from './helpers/authentication/AuthenticatedRoute'
import {Dashboard} from './containers'

const routes = [
  { path: '/', exact: true, name: 'Home', component: () => <AuthenticatedRoute component={<Full/>}/> },
  { path: '/dashboard', name: 'Dashboard', component: () => <AuthenticatedRoute component={<Dashboard/>}/> },
  { path: '/sistemas/themis', name: 'Themis', component: () => <AuthenticatedRoute component={<Themis/>}/> },
  { path: '/sistemas/cppro', name: 'Cppro', component: () => <AuthenticatedRoute component={<Cppro/>}/> },
  { path: '/spreadsheet', name: 'Planilha', component: () => <AuthenticatedRoute component={<SpreadsheetMigration/>}/> }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js